export const styles = theme => ({
    mobileStepperDivider: {
        [theme.breakpoints.up('md')]: {
            display: 'none',
        }
    },
    desktopStepper: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
            display: 'flex',
            marginTop: 12,
            padding: 0,
            maxWidth: 700,
            margin: 'auto',
            '& .steepLabel > span > span': {
                marginTop: 5,
            }
        }
    },
    desktopButtons: {
        marginTop: 0,
        display: 'none ',
        [theme.breakpoints.up('md')]: {
            display: 'flex ',
        }
    },
    mobileStepper: {
        display: 'flex',
        [theme.breakpoints.up('md')]: {
            display: 'none'
        }
    },
    modalPaper: {
        width: '90%',
        marginTop: '2%',
        [theme.breakpoints.up('md')]: {
            width: '40%',
            marginTop: '4%',
        },
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    tileImage: {
        display: 'block',
        height: '50%',
        width: '50%',
        [theme.breakpoints.up('md')]: {
            height: '65%',
            width: '50%',
        },
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    titleBar: {
        background: 'rgba(0,0,0,1)',
    },
    tabView: {
        padding: theme.spacing.unit * 2,
        paddingTop: '20px',
        width: 'auto',
        display: 'flex', // Fix IE 11 issue.
        marginLeft: theme.spacing.unit * 1,
        marginRight: theme.spacing.unit * 1,
        [theme.breakpoints.up(400 + theme.spacing.unit * 2 * 2)]: {
            width: 500,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    gridListRoot: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        overflow: 'hidden',
    },
    sheduleMain: {
        paddingTop: theme.spacing.unit * 1,
        paddingRight: theme.spacing.unit * 1,
        paddingLeft: theme.spacing.unit * 1,
        paddingBottom: theme.spacing.unit * 1,
        marginLeft: theme.spacing.unit * 1,
        marginRight: theme.spacing.unit * 1,
        marginBottom: theme.spacing.unit * 1,
        maxWidth: 500,
        [theme.breakpoints.up(400 + theme.spacing.unit * 2 * 2)]: {
            width: 500,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    formPaper: {
        maxWidth: 500,
        marginLeft: theme.spacing.unit * 1,
        marginRight: theme.spacing.unit * 1,
        marginBottom: theme.spacing.unit * 1,
        display: 'flex',
        flexDirection: 'column',
        padding: `${theme.spacing.unit * 1}px ${theme.spacing.unit * 1}px ${theme.spacing.unit * 1}px`,
        [theme.breakpoints.up(400 + theme.spacing.unit * 2 * 2)]: {
            width: 500,
            marginLeft: 'auto',
            marginRight: 'auto',
        }
    },
    itemPaper: {
        paddingTop: theme.spacing.unit * 1,
        paddingRight: theme.spacing.unit * 1,
        paddingLeft: theme.spacing.unit * 1,
        paddingBottom: theme.spacing.unit * 1,
        marginLeft: theme.spacing.unit * 1,
        marginRight: theme.spacing.unit * 1,
        marginBottom: theme.spacing.unit * 1,
    },
    main: {
        maxWidth: 500,
        marginLeft: theme.spacing.unit * 1,
        marginRight: theme.spacing.unit * 1,
        [theme.breakpoints.up(400 + theme.spacing.unit * 2 * 2)]: {
            width: 500,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    servicesItem: {
        marginLeft: '10px',
    },
    title: {
        fontWeight: 'bold',
    },
    image: {
        width: 50,
        height: 50,
        [theme.breakpoints.up('md')]: {
            width: 50,
            height: 50
        },
        margin: 'auto',
        display: 'block',
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing.unit,
    },
    paper1: {
        padding: theme.spacing.unit * 1,
        margin: 'auto',
        maxWidth: 350,
        marginBottom: "10px"
    },
    paper: {
        margin: 'auto',
        backgroundColor: 'transparent !important',
        '& > div': {
            backgroundColor: 'transparent !important',
        },
        [theme.breakpoints.up('md')]: {
            paddingLeft: '10%',
            paddingRight: '10%',
        }
    },
    submit: {
        marginTop: theme.spacing.unit * 3,
    },

    space: {
        marginLeft: 'auto',
        marginRight: 'auto',
        display: 'block',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        padding: `${theme.spacing.unit * 1}px ${theme.spacing.unit * 1}px ${theme.spacing.unit * 1}px`,
        [theme.breakpoints.up('md')]: {
            padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
            width: "50%",
        },
    },
    gridDesktopContent: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
            display: 'flex'
        }
    },
    fab: {
        position: 'fixed',
        bottom: theme.spacing.unit * 1,
        right: theme.spacing.unit * 2,
        [theme.breakpoints.up('md')]: {
            bottom: theme.spacing.unit * 10,
            right: theme.spacing.unit * 20,
        },
    },
    addContent: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
            display: 'flex',
        },
        marginTop: theme.spacing.unit * 1,
        marginBottom: theme.spacing.unit * 2,
        flexDirection: 'column',
        alignItems: 'center',
        padding: `${theme.spacing.unit * 1}px ${theme.spacing.unit * 1}px ${theme.spacing.unit * 1}px`,
    },
    lateralAddContent: {
        position: 'absolute',
        marginTop: theme.spacing.unit * 1,
        marginBottom: theme.spacing.unit * 2,
        right: 20,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
    },
    formControl: {
        display: 'block',
        marginLeft: 'auto',
        width: 'auto',
        marginRight: 'auto',
        minWidth: "120px"
    },
    root: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
    },
    bottomButtons: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '20px',
    },
    divider: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
            display: 'block',
        }
    },
    paperDiv: {
        backgroundColor: "#fff",
        marginBottom: '25px',
        [theme.breakpoints.up('sm')]: {
            backgroundColor: "transparent",
        },
        [theme.breakpoints.up('md')]: {
            boxShadow: 'none',
            borderRadius: 0,
            marginBottom: '60px',
        },
    },
    componentDiv: {
        minHeight: '200px',
    },
});
